import React, { useState } from 'react';

/**
 * @type {import('react').CSSProperties}
 */
const style = {
  background: 'none',
  color: '#969faf',
  border: 'none',
  padding: '4px',
  font: 'inherit',
  fontSize: '18px',
  cursor: 'pointer',
  outline: 'inherit',
};

function ToggleButton(props) {
  const [flag, setFlag] = useState(true);

  const onClick = (e) => {
    setFlag(!flag);
    props.onChange(flag);
  };

  const icon = flag ? props.true : props.false;

  return (
    <button style={style} onClick={onClick}>
      {icon}
    </button>
  );
}

export default ToggleButton;
